/**
 * Vista: Detalle/Nueva Encuesta de Satisfacción
 * Formato: AMX-VTA-FR-08
 */

import ventasService from '../services/ventas.service.js';
import tractorService from '../services/tractor.service.js';
import personaService from '../services/persona.service.js';
import recepcionService from '../services/recepcion.service.js';
import api from '../services/api.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

import { hoyLocal } from '../utils/fechas.js';
export default {
  data: {
    encuesta: null,
    tractor: null,
    isNew: false,
    clienteSeleccionado: null,
    distribuidores: [],
    responsablesCalidad: []
  },

  async render(params) {
    this.data.isNew = !params.id || params.id === 'nueva';

    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;" id="encuestaHeader">
          <h2 class="card-title">${this.data.isNew ? 'Nueva Encuesta de Satisfacción' : 'Encuesta de Satisfacción'}</h2>
          <button class="btn btn-secondary" onclick="window.encuestaDetalleView.volverALista()">
            Volver a Lista
          </button>
        </div>

        <div id="encuestaContent">
          <div style="text-align: center; padding: 2rem;">
            Cargando...
          </div>
        </div>
      </div>
    `;
  },

  async afterRender(params) {
    window.encuestaDetalleView = this;

    if (this.data.isNew) {
      await Promise.all([
        this.cargarDistribuidores(),
        this.cargarResponsablesCalidad(),
        this.cargarClientes()
      ]);
      this.renderFormularioNuevo();
    } else {
      await this.cargarEncuesta(params.id);
    }
  },

  async cargarClientes() {
    try {
      const response = await personaService.list({ rol: 'cliente', limit: 500 });
      const list = response.data?.personas || response.personas || response.data || response || [];
      this.data.clientes = Array.isArray(list) ? list : [];
    } catch (error) {
      console.error('Error al cargar clientes:', error);
      this.data.clientes = [];
    }
  },

  async cargarDistribuidores() {
    try {
      // Distribuidores desde usuarios con persona (patrón unificado)
      const response = await api.get('/usuarios/responsables');
      const todos = Array.isArray(response.data) ? response.data : (response.data?.usuarios || []);
      this.data.distribuidores = todos
        .filter(u => u.persona_id)
        .map(u => ({ id: u.persona_id, nombre_completo: u.persona_nombre_completo || u.nombre_completo }));
    } catch (error) {
      console.error('Error al cargar distribuidores:', error);
      this.data.distribuidores = [];
    }
  },

  async cargarResponsablesCalidad() {
    try {
      // Responsables de calidad desde usuarios con persona (patrón unificado)
      const response = await api.get('/usuarios/responsables');
      const todos = Array.isArray(response.data) ? response.data : (response.data?.usuarios || []);
      this.data.responsablesCalidad = todos
        .filter(u => u.persona_id)
        .map(u => ({ id: u.persona_id, nombre_completo: u.persona_nombre_completo || u.nombre_completo }));
    } catch (error) {
      console.error('Error al cargar responsables de calidad:', error);
      this.data.responsablesCalidad = [];
    }
  },

  encuestaIncompleta(e) {
    const campos = [
      'p1_atencion_agente', 'p2_explicacion_tecnica', 'p3_plan_financiamiento',
      'p4_medio_conocimiento', 'p5_tiempo_entrega', 'p6_asesoria_tecnica',
      'p7_explicacion_garantia', 'p8_cumplimiento_expectativas'
    ];
    return campos.some(c => e[c] === null || e[c] === undefined);
  },

  async cargarEncuesta(id) {
    try {
      const response = await ventasService.obtenerEncuesta(id);
      this.data.encuesta = response.data || response;

      await Promise.all([
        this.cargarDistribuidores(),
        this.cargarResponsablesCalidad()
      ]);

      if (!this.data.encuesta.completada) {
        this.renderFormularioEdicion();
      } else {
        this.renderFormularioEdicion(true);
      }
    } catch (error) {
      toast.error('Error al cargar encuesta');
      console.error(error);
      router.navigate('/ventas/encuestas');
    }
  },

  renderFormularioNuevo() {
    const container = document.getElementById('encuestaContent');

    container.innerHTML = `
      <form id="formEncuesta">
        <!-- Buscar Tractor -->
        <div style="background: white; border: 1px solid var(--gray-200); padding: 1.25rem 1.5rem; border-radius: 8px; margin-bottom: 1rem;">
          <h4 style="margin: 0 0 0.25rem; font-size: 1rem; font-weight: 600;">Buscar por número de serie</h4>
          <p style="margin: 0 0 1rem; color: var(--text-muted); font-size: 0.85rem;">Ingrese el número de serie del tractor para cargar sus datos automáticamente</p>
          <div style="display: flex; gap: 0.75rem; align-items: center;">
            <input
              type="text"
              id="numSerieBuscar"
              class="form-input"
              style="flex: 1;"
              placeholder="Ej: TE354-2026-0127"
            />
            <button type="button" class="btn btn-primary" onclick="window.encuestaDetalleView.buscarTractor()">
              Buscar
            </button>
          </div>
          <div id="tractorResult" style="margin-top: 1rem;"></div>
        </div>

        <!-- Formulario principal -->
        <div id="formularioPrincipal" style="display: none;">
          <input type="hidden" name="num_serie" id="numSerie" />

          <!-- Datos del Usuario -->
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; margin-top: -0.5rem;">
            <h3 style="margin-bottom: 1rem;">Datos de Identificación</h3>
            <!-- Marca y Modelo (lado a lado) -->
            <div class="encuesta-row-2col" style="margin-bottom: 1rem;">
              <div class="form-group">
                <label class="form-label">Marca</label>
                <input
                  type="text"
                  id="marcaDisplay"
                  class="form-input"
                  readonly
                  style="background: var(--bg-primary); cursor: not-allowed;"
                />
                <input type="hidden" name="marca" id="marca" />
              </div>
              <div class="form-group">
                <label class="form-label">Modelo</label>
                <input
                  type="text"
                  name="modelo"
                  id="modelo"
                  class="form-input"
                  readonly
                  style="background: var(--bg-primary); cursor: not-allowed;"
                />
              </div>
            </div>

            <!-- Cliente (ancho completo) -->
            <div class="form-group" style="margin-bottom: 1rem;">
              <label class="form-label">Cliente *</label>
              <input type="hidden" name="cliente_id" id="clienteId" />
              <input type="hidden" name="usuario" id="clienteNombre" />
              <select id="clienteSelect" class="form-select" onchange="window.encuestaDetalleView._onClienteSelectChange(this)">
                <option value="">Seleccione un cliente...</option>
                ${(this.data.clientes || []).map(c => `
                  <option value="${c.id}" data-nombre="${c.nombre_completo}" data-rfc="${c.rfc || ''}">${c.nombre_completo}${c.rfc ? ` - ${c.rfc}` : ''}</option>
                `).join('')}
              </select>
            </div>

            <!-- Fechas (lado a lado) -->
            <div class="encuesta-row-2col">
              <div class="form-group">
                <label class="form-label">Fecha de Entrega *</label>
                <input
                  type="date"
                  name="fecha_entrega"
                  class="form-input"
                  required
                />
              </div>
              <div class="form-group">
                <label class="form-label">Fecha de Evaluación</label>
                <input
                  type="date"
                  name="fecha_evaluacion"
                  class="form-input"
                  value="${hoyLocal()}"
                />
              </div>
            </div>
          </div>

          <!-- Tabs de secciones -->
          <div class="encuesta-tabs-bar">
            <button type="button" class="encuesta-tab active" onclick="window.encuestaDetalleView.showTab('ventas')">Ventas</button>
            <button type="button" class="encuesta-tab" onclick="window.encuestaDetalleView.showTab('almacen')">Almacén</button>
            <button type="button" class="encuesta-tab" onclick="window.encuestaDetalleView.showTab('observaciones')">Observaciones</button>
            <button type="button" class="encuesta-tab" onclick="window.encuestaDetalleView.showTab('responsables')">Responsables</button>
          </div>

          <!-- Paneles (show/hide) -->
          <div class="encuesta-panel" id="panel-ventas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">1. ¿Cómo calificaría la atención brindada por nuestro agente comercial antes, durante y después del protocolo de entrega? *</label>
              <div class="encuesta-radio-group">
                ${[1,2,3,4,5].map(n => `
                  <label class="encuesta-radio-label">
                    <input type="radio" name="p1_atencion_agente" value="${n}" />
                    <span>${n}</span>
                  </label>
                `).join('')}
                <span class="encuesta-radio-hint">(1=Malo, 5=Excelente)</span>
              </div>
            </div>
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">2. ¿Cómo considera la explicación de las características técnicas y especificaciones de su equipo realizada por nuestro agente comercial? *</label>
              <div class="encuesta-radio-group">
                ${[1,2,3,4,5].map(n => `
                  <label class="encuesta-radio-label">
                    <input type="radio" name="p2_explicacion_tecnica" value="${n}" />
                    <span>${n}</span>
                  </label>
                `).join('')}
                <span class="encuesta-radio-hint">(1=Malo, 5=Excelente)</span>
              </div>
            </div>
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">3. ¿Nuestro agente comercial le ofreció un plan de financiamiento? *</label>
              <div class="encuesta-radio-group">
                <label class="encuesta-radio-label">
                  <input type="radio" name="p3_plan_financiamiento" value="true" />
                  <span>Sí</span>
                </label>
                <label class="encuesta-radio-label">
                  <input type="radio" name="p3_plan_financiamiento" value="false" />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">4. ¿Por qué medio conoció nuestros productos? *</label>
              <div class="encuesta-radio-group">
                ${['evento', 'internet', 'redes_sociales', 'cliente', 'otro'].map(v => `
                  <label class="encuesta-radio-label">
                    <input type="radio" name="p4_medio_conocimiento" value="${v}" />
                    <span>${{evento:'Evento', internet:'Internet', redes_sociales:'Redes Sociales', cliente:'Cliente', otro:'Otro'}[v]}</span>
                  </label>
                `).join('')}
              </div>
            </div>
          </div>

          <div class="encuesta-panel" id="panel-almacen" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem; display: none;">
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">5. ¿El tiempo de entrega fue según lo acordado? *</label>
              <div class="encuesta-radio-group">
                <label class="encuesta-radio-label">
                  <input type="radio" name="p5_tiempo_entrega" value="true" />
                  <span>Sí</span>
                </label>
                <label class="encuesta-radio-label">
                  <input type="radio" name="p5_tiempo_entrega" value="false" />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">6. Al recibir su equipo, ¿nuestro personal le brindó asesoría técnica sobre su correcto funcionamiento y desempeño? *</label>
              <div class="encuesta-radio-group">
                <label class="encuesta-radio-label">
                  <input type="radio" name="p6_asesoria_tecnica" value="true" />
                  <span>Sí</span>
                </label>
                <label class="encuesta-radio-label">
                  <input type="radio" name="p6_asesoria_tecnica" value="false" />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div class="form-group" style="margin-bottom: 1.5rem;">
              <label class="form-label">7. ¿Nuestro personal técnico le explicó las CONDICIONES DE GARANTÍA y SERVICIOS DE MANTENIMIENTO de su equipo? *</label>
              <div class="encuesta-radio-group">
                <label class="encuesta-radio-label">
                  <input type="radio" name="p7_explicacion_garantia" value="true" />
                  <span>Sí</span>
                </label>
                <label class="encuesta-radio-label">
                  <input type="radio" name="p7_explicacion_garantia" value="false" />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">8. ¿Que tanto cumplió con sus expectativas el equipo entregado? *</label>
              <div class="encuesta-radio-group">
                ${[1,2,3,4,5].map(n => `
                  <label class="encuesta-radio-label">
                    <input type="radio" name="p8_cumplimiento_expectativas" value="${n}" />
                    <span>${n}</span>
                  </label>
                `).join('')}
                <span class="encuesta-radio-hint">(1=No cumplió, 5=Superó expectativas)</span>
              </div>
            </div>
          </div>

          <div class="encuesta-panel" id="panel-observaciones" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem; display: none;">
            <div class="form-group">
              <label class="form-label">Observaciones</label>
              <textarea name="observaciones" class="form-input" rows="5" placeholder="Comentarios adicionales del cliente..." style="text-transform: uppercase;"></textarea>
            </div>
          </div>

          <div class="encuesta-panel" id="panel-responsables" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem; display: none;">
            <div class="encuesta-row-2col" style="margin-bottom: 1rem;">
              <div class="form-group">
                <label class="form-label">Distribuidor *</label>
                <select name="distribuidor" id="distribuidorSelect" class="form-select">
                  <option value="">Seleccione un distribuidor...</option>
                  ${(this.data.distribuidores || []).map(d => `
                    <option value="${d.nombre_completo}">${d.nombre_completo}</option>
                  `).join('')}
                </select>
              </div>
              <div class="form-group">
                <label class="form-label">Responsable de Calidad *</label>
                <select name="responsable_calidad" id="responsableCalidadSelect" class="form-select">
                  <option value="">Seleccione un responsable...</option>
                  ${(this.data.responsablesCalidad || []).map(r => `
                    <option value="${r.nombre_completo}">${r.nombre_completo}</option>
                  `).join('')}
                </select>
              </div>
            </div>
          </div>

          <!-- Botones -->
          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button type="button" class="btn btn-secondary" onclick="router.navigate('/ventas/encuestas')">
              Cancelar
            </button>
            <button type="submit" class="btn btn-success">
              Registrar Encuesta
            </button>
          </div>
        </div>
      </form>
    `;

    document.getElementById('formEncuesta').addEventListener('submit', (e) => this.guardarNueva(e));

    // Buscar al presionar Enter; ocultar formulario si modifican el NS después de buscar
    const nsBuscar = document.getElementById('numSerieBuscar');
    if (nsBuscar) {
      nsBuscar.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.buscarTractor();
        }
      });
      nsBuscar.addEventListener('input', () => {
        if (this.data.tractor) {
          this.data.tractor = null;
          const fp = document.getElementById('formularioPrincipal');
          if (fp) fp.style.display = 'none';
          const result = document.getElementById('tractorResult');
          if (result) result.innerHTML = '';
        }
      });
    }

    // Estilo para tabs
    if (!document.querySelector('style[data-encuesta-tabs]')) {
      const style = document.createElement('style');
      style.setAttribute('data-encuesta-tabs', '');
      style.textContent = `
        .encuesta-tabs-bar {
          display: flex;
          padding: 0;
          background: transparent;
          border-bottom: 2px solid #e5e7eb;
          margin-bottom: 1rem;
        }
        .encuesta-tab {
          flex: 1;
          padding: 0.6rem 1rem;
          border: none;
          border-bottom: 3px solid transparent;
          margin-bottom: -2px;
          background: transparent;
          color: #6b7280;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          text-align: center;
        }
        .encuesta-tab:hover:not(.active) {
          color: #374151;
          border-bottom-color: #d1d5db;
        }
        .encuesta-tab.active {
          color: var(--primary);
          font-weight: 600;
          border-bottom-color: var(--primary);
        }
        .encuesta-radio-group {
          display: flex;
          gap: 1rem;
          margin-top: 0.5rem;
          flex-wrap: wrap;
        }
        .encuesta-radio-label {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          cursor: pointer;
        }
        .encuesta-radio-hint {
          color: var(--text-muted);
          font-size: 0.875rem;
        }
        .encuesta-detalle-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 0.5rem;
          border-bottom: 1px solid var(--border-color);
          padding: 0.5rem 0;
        }
        .encuesta-detalle-row:last-child {
          border-bottom: none;
        }
        .encuesta-buscar-tractor {
          display: flex;
          gap: 1rem;
          align-items: center;
        }
        .encuesta-row-2col {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }
        @media (max-width: 640px) {
          .encuesta-tabs-bar {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 0.3rem;
            padding: 0.3rem;
          }
          .encuesta-tab {
            padding: 0.4rem 0.5rem;
            font-size: 0.75rem;
          }
          .encuesta-radio-group {
            gap: 0.5rem;
          }
          .encuesta-radio-hint {
            width: 100%;
            font-size: 0.75rem;
          }
          .encuesta-detalle-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.25rem;
          }
          .encuesta-buscar-tractor .btn {
            align-self: flex-start;
          }
          .encuesta-row-2col {
            grid-template-columns: 1fr;
          }
        }
      `;
      document.head.appendChild(style);
    }

    // Configurar búsqueda de clientes
    this.setupBusquedaClientes();
  },

  showTab(tab) {
    // Actualizar botones activos
    document.querySelectorAll('#formularioPrincipal .encuesta-tab').forEach(btn => btn.classList.remove('active'));
    const tabButton = document.querySelector(`#formularioPrincipal .encuesta-tab[onclick*="'${tab}'"]`);
    if (tabButton) tabButton.classList.add('active');

    // Mostrar/ocultar paneles
    document.querySelectorAll('#formularioPrincipal .encuesta-panel').forEach(p => p.style.display = 'none');
    const panel = document.getElementById(`panel-${tab}`);
    if (panel) panel.style.display = 'block';

  },

  async initFirmas() {
    // Cargar SignaturePad si no está
    if (!window.SignaturePad) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    setTimeout(() => {
      ['distribuidor', 'responsable'].forEach(tipo => {
        const canvas = document.getElementById(`firma-${tipo}`);
        if (!canvas) return;

        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);

        const pad = new SignaturePad(canvas, {
          backgroundColor: 'rgb(255, 255, 255)',
          penColor: 'rgb(0, 0, 0)'
        });

        this[`signaturePad_${tipo}`] = pad;

        const placeholder = canvas.parentElement.querySelector('.firma-placeholder');
        const hideOnDraw = () => { if (placeholder) placeholder.style.display = 'none'; };
        canvas.addEventListener('pointerdown', hideOnDraw);
        canvas.addEventListener('touchstart', hideOnDraw);

        // Activar "Hay cambios sin guardar" al terminar un trazo
        if (this._showUnsaved) pad.addEventListener('endStroke', () => this._showUnsaved());
      });
    }, 100);
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  },

  limpiarFirma(tipo) {
    const pad = this[`signaturePad_${tipo}`];
    if (pad) {
      pad.clear();
      const canvas = document.getElementById(`firma-${tipo}`);
      const placeholder = canvas?.parentElement.querySelector('.firma-placeholder');
      if (placeholder) placeholder.style.display = 'block';
    }
  },

  cambiarFirmaExistente(tipo) {
    const enc = this.data.encuesta;
    if (!enc) return;
    if (tipo === 'distribuidor') enc.distribuidor_firma_url = null;
    if (tipo === 'responsable') enc.responsable_calidad_firma_url = null;
    this[`signaturePad_${tipo}`] = null;
    this._showUnsaved();
    this.renderFormularioEdicion();
    this.showTabEdit('firmas');
  },

  async toBlob(signaturePad) {
    const dataURL = signaturePad.toDataURL('image/png');
    const response = await fetch(dataURL);
    return response.blob();
  },

  async subirFirmas() {
    const urls = { distribuidor_firma_url: null, responsable_calidad_firma_url: null };

    const enc = this.data.encuesta;
    const padDist = this.signaturePad_distribuidor;
    const padResp = this.signaturePad_responsable;

    const uploads = [];

    const numSerie = enc?.num_serie;

    // Guarda por URL: solo subir si NO existe URL persistida.
    // "Cambiar firma" pone la URL a null, así que la única vía para re-subir es ese flujo.
    if (!enc?.distribuidor_firma_url && padDist && !padDist.isEmpty()) {
      uploads.push(
        recepcionService.subirFirma(await this.toBlob(padDist), `firma-dist-encuesta-${Date.now()}.png`, numSerie, 'encuesta')
          .then(url => { urls.distribuidor_firma_url = url; })
      );
    }

    if (!enc?.responsable_calidad_firma_url && padResp && !padResp.isEmpty()) {
      uploads.push(
        recepcionService.subirFirma(await this.toBlob(padResp), `firma-resp-encuesta-${Date.now()}.png`, numSerie, 'encuesta')
          .then(url => { urls.responsable_calidad_firma_url = url; })
      );
    }

    if (uploads.length > 0) await Promise.all(uploads);
    return urls;
  },

  setupBusquedaClientes() {
    // Deprecado: ahora se usa un <select> estático. Mantener método por compatibilidad.
  },

  seleccionarCliente(id, nombre, rfc) {
    this.data.clienteSeleccionado = { id, nombre, rfc };
    const idEl = document.getElementById('clienteId');
    const nombreEl = document.getElementById('clienteNombre');
    if (idEl) idEl.value = id;
    if (nombreEl) nombreEl.value = nombre;
    // Sincronizar el select con el cliente seleccionado
    const selectEl = document.getElementById('clienteSelect');
    if (selectEl) selectEl.value = String(id);
  },

  _onClienteSelectChange(select) {
    if (!select.value) {
      this.limpiarCliente();
      return;
    }
    const option = select.options[select.selectedIndex];
    this.seleccionarCliente(
      parseInt(select.value, 10),
      option.dataset.nombre || '',
      option.dataset.rfc || ''
    );
  },

  limpiarCliente() {
    this.data.clienteSeleccionado = null;
    const idEl = document.getElementById('clienteId');
    const nombreEl = document.getElementById('clienteNombre');
    const selectEl = document.getElementById('clienteSelect');
    if (idEl) idEl.value = '';
    if (nombreEl) nombreEl.value = '';
    if (selectEl) selectEl.value = '';
  },

  async buscarTractor() {
    const numSerie = document.getElementById('numSerieBuscar').value;
    if (!numSerie) {
      toast.error('Ingrese el número de serie');
      return;
    }

    const resultDiv = document.getElementById('tractorResult');
    resultDiv.innerHTML = '<p>Buscando...</p>';

    try {
      const response = await tractorService.getByNumSerie(numSerie);
      const tractor = response.data || response;
      this.data.tractor = tractor;

      // Verificar si el tractor tiene cliente asignado
      const tieneCliente = tractor.cliente && tractor.cliente.id;

      resultDiv.innerHTML = '';

      // Mostrar formulario y prellenar datos
      document.getElementById('formularioPrincipal').style.display = 'block';
      document.getElementById('numSerie').value = numSerie;
      document.getElementById('modelo').value = tractor.modelo || '';
      document.getElementById('marca').value = tractor.marca || '';
      document.getElementById('marcaDisplay').value = tractor.marca || '';

      // Auto-rellenar cliente desde el tractor si existe
      if (tieneCliente) {
        this.seleccionarCliente(
          tractor.cliente.id,
          tractor.cliente.nombre,
          tractor.cliente.rfc
        );
      }

    } catch (error) {
      this.data.tractor = null;
      resultDiv.innerHTML = `
        <div style="padding: 1rem; background: var(--danger); color: white; border-radius: 8px;">
          ${error.message || 'Tractor no encontrado'}
        </div>
      `;
      document.getElementById('formularioPrincipal').style.display = 'none';
      console.error(error);
    }
  },

  renderEncuestaExistente() {
    const container = document.getElementById('encuestaContent');
    const e = this.data.encuesta;

    container.innerHTML = `
      <!-- Encabezado -->
      <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem;">
          <div><strong>Num. Serie:</strong><br><span style="font-size: 1.1rem;">${e.num_serie}</span></div>
          <div><strong>Marca:</strong><br>${e.marca}</div>
          <div><strong>Modelo:</strong><br>${e.modelo}</div>
          <div><strong>Usuario:</strong><br>${e.usuario || '-'}</div>
          <div><strong>Fecha Entrega:</strong><br>${e.fecha_entrega ? new Date(e.fecha_entrega).toLocaleDateString('es-MX') : '-'}</div>
          <div><strong>Fecha Evaluación:</strong><br>${e.fecha_evaluacion ? new Date(e.fecha_evaluacion).toLocaleDateString('es-MX') : '-'}</div>
        </div>
      </div>

      <!-- Tabs de secciones -->
      <div class="encuesta-tabs-bar">
        <button class="encuesta-tab active" onclick="window.encuestaDetalleView.showTabDetalle('ventas')">Ventas</button>
        <button class="encuesta-tab" onclick="window.encuestaDetalleView.showTabDetalle('almacen')">Almacén</button>
        <button class="encuesta-tab" onclick="window.encuestaDetalleView.showTabDetalle('observaciones')">Observaciones</button>
        <button class="encuesta-tab" onclick="window.encuestaDetalleView.showTabDetalle('responsables')">Responsables</button>
      </div>

      <!-- Paneles detalle (show/hide) -->
      <div class="encuesta-panel-detalle" id="panel-detalle-ventas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
        <div style="display: grid; grid-template-columns: 1fr; gap: 0.5rem;">
          <div class="encuesta-detalle-row">
            <span>1. Atención brindada por el agente comercial:</span>
            ${e.p1_atencion_agente != null ? `<span class="badge ${this.getCalificacionBadge(e.p1_atencion_agente)}">${e.p1_atencion_agente}/5</span>` : '<span class="badge badge-secondary">Sin responder</span>'}
          </div>
          <div class="encuesta-detalle-row">
            <span>2. Explicación de características técnicas y especificaciones:</span>
            ${e.p2_explicacion_tecnica != null ? `<span class="badge ${this.getCalificacionBadge(e.p2_explicacion_tecnica)}">${e.p2_explicacion_tecnica}/5</span>` : '<span class="badge badge-secondary">Sin responder</span>'}
          </div>
          <div class="encuesta-detalle-row">
            <span>3. ¿Nuestro agente comercial le ofreció un plan de financiamiento?</span>
            ${e.p3_plan_financiamiento != null ? `<span class="badge ${e.p3_plan_financiamiento ? 'badge-success' : 'badge-warning'}">${e.p3_plan_financiamiento ? 'Sí' : 'No'}</span>` : '<span class="badge badge-secondary">Sin responder</span>'}
          </div>
          <div class="encuesta-detalle-row">
            <span>4. Medio por el que conoció los productos:</span>
            ${e.p4_medio_conocimiento ? `<span class="badge badge-info">${this.formatMedio(e.p4_medio_conocimiento)}</span>` : '<span class="badge badge-secondary">Sin responder</span>'}
          </div>
        </div>
      </div>

      <div class="encuesta-panel-detalle" id="panel-detalle-almacen" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem; display: none;">
        <div style="display: grid; grid-template-columns: 1fr; gap: 0.5rem;">
          <div class="encuesta-detalle-row">
            <span>5. ¿Tiempo de entrega según lo acordado?</span>
            ${e.p5_tiempo_entrega != null ? `<span class="badge ${e.p5_tiempo_entrega ? 'badge-success' : 'badge-warning'}">${e.p5_tiempo_entrega ? 'Sí' : 'No'}</span>` : '<span class="badge badge-secondary">Sin responder</span>'}
          </div>
          <div class="encuesta-detalle-row">
            <span>6. ¿Asesoría técnica sobre funcionamiento y desempeño?</span>
            ${e.p6_asesoria_tecnica != null ? `<span class="badge ${e.p6_asesoria_tecnica ? 'badge-success' : 'badge-warning'}">${e.p6_asesoria_tecnica ? 'Sí' : 'No'}</span>` : '<span class="badge badge-secondary">Sin responder</span>'}
          </div>
          <div class="encuesta-detalle-row">
            <span>7. ¿Explicación de condiciones de garantía y servicios de mantenimiento?</span>
            ${e.p7_explicacion_garantia != null ? `<span class="badge ${e.p7_explicacion_garantia ? 'badge-success' : 'badge-warning'}">${e.p7_explicacion_garantia ? 'Sí' : 'No'}</span>` : '<span class="badge badge-secondary">Sin responder</span>'}
          </div>
          <div class="encuesta-detalle-row">
            <span>8. ¿Que tanto cumplió con sus expectativas el equipo entregado?</span>
            ${e.p8_cumplimiento_expectativas != null ? `<span class="badge ${this.getCalificacionBadge(e.p8_cumplimiento_expectativas)}">${e.p8_cumplimiento_expectativas}/5</span>` : '<span class="badge badge-secondary">Sin responder</span>'}
          </div>
        </div>
      </div>

      <div class="encuesta-panel-detalle" id="panel-detalle-observaciones" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem; display: none;">
        <p>${e.observaciones || '<em style="color: var(--text-muted);">Sin observaciones</em>'}</p>
      </div>

      <div class="encuesta-panel-detalle" id="panel-detalle-responsables" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem; display: none;">
        <div class="encuesta-row-2col" style="margin-bottom: 1rem;">
          <div><strong>Distribuidor:</strong><br>${e.distribuidor || '<em style="color: var(--text-muted);">No especificado</em>'}</div>
          <div><strong>Responsable de Calidad:</strong><br>${e.responsable_calidad || '<em style="color: var(--text-muted);">No especificado</em>'}</div>
        </div>
        <div class="encuesta-row-2col">
          <div>
            <strong>Firma Distribuidor:</strong><br>
            ${e.distribuidor_firma_url
              ? `<img src="${e.distribuidor_firma_url}" alt="Firma distribuidor" style="max-width: 100%; max-height: 150px; border: 1px solid var(--border-color); border-radius: 8px; background: white;" />`
              : '<em style="color: var(--text-muted);">Sin firma</em>'}
          </div>
          <div>
            <strong>Firma Responsable de Calidad:</strong><br>
            ${e.responsable_calidad_firma_url
              ? `<img src="${e.responsable_calidad_firma_url}" alt="Firma responsable" style="max-width: 100%; max-height: 150px; border: 1px solid var(--border-color); border-radius: 8px; background: white;" />`
              : '<em style="color: var(--text-muted);">Sin firma</em>'}
          </div>
        </div>
      </div>

      <!-- Estado -->
      <div style="margin-bottom: 1rem;">
        <span class="badge badge-success" style="font-size: 0.9rem; padding: 0.4rem 0.8rem;">
          Completada
        </span>
      </div>

      <!-- Botones -->
      <div style="display: flex; gap: 1rem; justify-content: flex-end;">
        <button class="btn btn-secondary" onclick="router.navigate('/ventas/encuestas')">
          Volver
        </button>
      </div>
    `;

    // Estilo para tabs (si no se agregó ya)
    if (!document.querySelector('style[data-encuesta-tabs]')) {
      const style = document.createElement('style');
      style.setAttribute('data-encuesta-tabs', '');
      style.textContent = `
        .encuesta-tabs-bar {
          display: flex;
          padding: 0;
          background: transparent;
          border-bottom: 2px solid #e5e7eb;
          margin-bottom: 1rem;
        }
        .encuesta-tab {
          flex: 1;
          padding: 0.6rem 1rem;
          border: none;
          border-bottom: 3px solid transparent;
          margin-bottom: -2px;
          background: transparent;
          color: #6b7280;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          text-align: center;
        }
        .encuesta-tab:hover:not(.active) {
          color: #374151;
          border-bottom-color: #d1d5db;
        }
        .encuesta-tab.active {
          color: var(--primary);
          font-weight: 600;
          border-bottom-color: var(--primary);
        }
        .encuesta-radio-group {
          display: flex;
          gap: 1rem;
          margin-top: 0.5rem;
          flex-wrap: wrap;
        }
        .encuesta-radio-label {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          cursor: pointer;
        }
        .encuesta-radio-hint {
          color: var(--text-muted);
          font-size: 0.875rem;
        }
        .encuesta-detalle-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 0.5rem;
          border-bottom: 1px solid var(--border-color);
          padding: 0.5rem 0;
        }
        .encuesta-detalle-row:last-child {
          border-bottom: none;
        }
        .encuesta-buscar-tractor {
          display: flex;
          gap: 1rem;
          align-items: center;
        }
        .encuesta-row-2col {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }
        @media (max-width: 640px) {
          .encuesta-tabs-bar {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 0.3rem;
            padding: 0.3rem;
          }
          .encuesta-tab {
            padding: 0.4rem 0.5rem;
            font-size: 0.75rem;
          }
          .encuesta-radio-group {
            gap: 0.5rem;
          }
          .encuesta-radio-hint {
            width: 100%;
            font-size: 0.75rem;
          }
          .encuesta-detalle-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.25rem;
          }
          .encuesta-buscar-tractor .btn {
            align-self: flex-start;
          }
          .encuesta-row-2col {
            grid-template-columns: 1fr;
          }
        }
      `;
      document.head.appendChild(style);
    }
  },

  showTabDetalle(tab) {
    document.querySelectorAll('#encuestaContent .encuesta-tab').forEach(btn => btn.classList.remove('active'));
    const tabButton = document.querySelector(`#encuestaContent .encuesta-tab[onclick*="'${tab}'"]`);
    if (tabButton) tabButton.classList.add('active');

    document.querySelectorAll('.encuesta-panel-detalle').forEach(p => p.style.display = 'none');
    const panel = document.getElementById(`panel-detalle-${tab}`);
    if (panel) panel.style.display = 'block';
  },

  getCalificacionBadge(calificacion) {
    if (calificacion >= 4) return 'badge-success';
    if (calificacion >= 3) return 'badge-warning';
    return 'badge-danger';
  },

  formatMedio(medio) {
    const medios = {
      'evento': 'Evento',
      'internet': 'Internet',
      'redes_sociales': 'Redes Sociales',
      'cliente': 'Cliente',
      'otro': 'Otro'
    };
    return medios[medio] || medio;
  },

  async guardarNueva(e) {
    e.preventDefault();

    if (!this.data.tractor) {
      toast.error('Debe buscar y seleccionar un tractor válido primero');
      return;
    }

    // Validar que se haya seleccionado un cliente
    if (!this.data.clienteSeleccionado) {
      toast.error('Debe seleccionar un cliente del catálogo');
      document.getElementById('clienteSelect')?.focus();
      return;
    }

    const form = e.target;
    const formData = new FormData(form);

    const data = {
      num_serie: formData.get('num_serie'),
      usuario: formData.get('usuario') || null,
      cliente_id: formData.get('cliente_id') ? parseInt(formData.get('cliente_id')) : null,
      marca: formData.get('marca') || null,
      modelo: formData.get('modelo') || null,
      fecha_entrega: formData.get('fecha_entrega') || null,
      fecha_evaluacion: formData.get('fecha_evaluacion') || null,
      p1_atencion_agente: formData.get('p1_atencion_agente') ? parseInt(formData.get('p1_atencion_agente')) : null,
      p2_explicacion_tecnica: formData.get('p2_explicacion_tecnica') ? parseInt(formData.get('p2_explicacion_tecnica')) : null,
      p3_plan_financiamiento: formData.get('p3_plan_financiamiento') != null ? formData.get('p3_plan_financiamiento') === 'true' : null,
      p4_medio_conocimiento: formData.get('p4_medio_conocimiento') || null,
      p5_tiempo_entrega: formData.get('p5_tiempo_entrega') != null ? formData.get('p5_tiempo_entrega') === 'true' : null,
      p6_asesoria_tecnica: formData.get('p6_asesoria_tecnica') != null ? formData.get('p6_asesoria_tecnica') === 'true' : null,
      p7_explicacion_garantia: formData.get('p7_explicacion_garantia') != null ? formData.get('p7_explicacion_garantia') === 'true' : null,
      p8_cumplimiento_expectativas: formData.get('p8_cumplimiento_expectativas') ? parseInt(formData.get('p8_cumplimiento_expectativas')) : null,
      observaciones: formData.get('observaciones') ? formData.get('observaciones').toUpperCase() : null,
      distribuidor: formData.get('distribuidor') || null,
      responsable_calidad: formData.get('responsable_calidad') || null
    };

    // Validar responsables
    if (!formData.get('distribuidor')) {
      toast.error('Debe seleccionar un distribuidor');
      this.showTab('responsables');
      return;
    }
    if (!formData.get('responsable_calidad')) {
      toast.error('Debe seleccionar un responsable de calidad');
      this.showTab('responsables');
      return;
    }

    // Quitar campos null para no enviarlos al backend
    Object.keys(data).forEach(k => { if (data[k] === null || data[k] === undefined) delete data[k]; });

    try {
      const response = await ventasService.crearEncuesta(data);
      toast.success('Encuesta registrada exitosamente');
      const encuesta = response.data || response;
      router.navigate(`/ventas/encuestas/${encuesta.id}`);
    } catch (error) {
      toast.error(error.message || 'Error al registrar encuesta');
      console.error(error);
    }
  },

  async guardarYCompletar() {
    // Si hay cambios pendientes, exigir guardar primero (patrón unificado)
    if (this._hasUnsaved) {
      toast.warning('Guarde los cambios antes de completar la encuesta');
      return;
    }

    const form = document.getElementById('formEditEncuesta');
    if (!form) return;

    const formData = new FormData(form);
    const enc = this.data.encuesta;

    // Validar preguntas VENTAS
    const ventasFaltantes = [];
    if (!formData.get('p1_atencion_agente')) ventasFaltantes.push('Pregunta 1 (Atención agente)');
    if (!formData.get('p2_explicacion_tecnica')) ventasFaltantes.push('Pregunta 2 (Explicación técnica)');
    if (formData.get('p3_plan_financiamiento') == null) ventasFaltantes.push('Pregunta 3 (Plan financiamiento)');
    if (!formData.get('p4_medio_conocimiento')) ventasFaltantes.push('Pregunta 4 (Medio conocimiento)');

    if (ventasFaltantes.length > 0) {
      toast.error('Complete todas las preguntas de Ventas');
      this.showTabEdit('ventas');
      return;
    }

    // Validar preguntas ALMACÉN
    const almacenFaltantes = [];
    if (formData.get('p5_tiempo_entrega') == null) almacenFaltantes.push(5);
    if (formData.get('p6_asesoria_tecnica') == null) almacenFaltantes.push(6);
    if (formData.get('p7_explicacion_garantia') == null) almacenFaltantes.push(7);
    if (!formData.get('p8_cumplimiento_expectativas')) almacenFaltantes.push(8);

    if (almacenFaltantes.length > 0) {
      toast.error('Complete todas las preguntas de Almacén');
      this.showTabEdit('almacen');
      return;
    }

    // Validar firmas persistidas (ya guardadas con "Guardar cambios")
    if (!enc.distribuidor_firma_url || !enc.responsable_calidad_firma_url) {
      toast.error('Faltan firmas de los responsables');
      this.showTabEdit('firmas');
      return;
    }

    if (!confirm('¿Está seguro de completar esta encuesta? Una vez completada no se podrá editar ni eliminar.')) return;

    {

      const data = {
        p1_atencion_agente: formData.get('p1_atencion_agente') ? parseInt(formData.get('p1_atencion_agente')) : undefined,
        p2_explicacion_tecnica: formData.get('p2_explicacion_tecnica') ? parseInt(formData.get('p2_explicacion_tecnica')) : undefined,
        p3_plan_financiamiento: formData.get('p3_plan_financiamiento') != null ? formData.get('p3_plan_financiamiento') === 'true' : undefined,
        p4_medio_conocimiento: formData.get('p4_medio_conocimiento') || undefined,
        p5_tiempo_entrega: formData.get('p5_tiempo_entrega') != null ? formData.get('p5_tiempo_entrega') === 'true' : undefined,
        p6_asesoria_tecnica: formData.get('p6_asesoria_tecnica') != null ? formData.get('p6_asesoria_tecnica') === 'true' : undefined,
        p7_explicacion_garantia: formData.get('p7_explicacion_garantia') != null ? formData.get('p7_explicacion_garantia') === 'true' : undefined,
        p8_cumplimiento_expectativas: formData.get('p8_cumplimiento_expectativas') ? parseInt(formData.get('p8_cumplimiento_expectativas')) : undefined,
        observaciones: formData.get('observaciones') ? formData.get('observaciones').toUpperCase() : null
      };

      Object.keys(data).forEach(k => { if (data[k] === undefined || data[k] === null) delete data[k]; });

      try {
        // Firmas ya persistidas con "Guardar cambios" — no se re-suben.
        if (Object.keys(data).length > 0) {
          await ventasService.actualizarEncuesta(enc.id, data);
        }

        // Luego completar (solo cambia estado)
        await ventasService.completarEncuesta(enc.id);
        this._clearUnsaved();
        if (this._beforeUnloadHandler) window.removeEventListener('beforeunload', this._beforeUnloadHandler);
        toast.success('Encuesta completada exitosamente');
        this.data.isEdit = false;
        await this.cargarEncuesta(enc.id);
      } catch (error) {
        toast.error(error.message || 'Error al completar encuesta');
        console.error(error);
      }
    }
  },

  async completarEncuesta() {
    if (!confirm('¿Está seguro de completar esta encuesta? Una vez completada no se podrá editar ni eliminar.')) return;

    try {
      await ventasService.completarEncuesta(this.data.encuesta.id);
      toast.success('Encuesta completada exitosamente');
      await this.cargarEncuesta(this.data.encuesta.id);
    } catch (error) {
      toast.error(error.message || 'Error al completar encuesta');
      console.error(error);
    }
  },

  async eliminarEncuesta() {
    if (!confirm('¿Está seguro de eliminar esta encuesta? Esta acción no se puede deshacer.')) return;

    try {
      await ventasService.eliminarEncuesta(this.data.encuesta.id);
      toast.success('Encuesta eliminada exitosamente');
      router.navigate('/ventas/encuestas');
    } catch (error) {
      toast.error(error.message || 'Error al eliminar encuesta');
      console.error(error);
    }
  },

  // =====================================================
  // EDICIÓN DE ENCUESTA
  // =====================================================

  async activarEdicion() {
    this.data.isEdit = true;
    await Promise.all([
      this.cargarDistribuidores(),
      this.cargarResponsablesCalidad()
    ]);
    this.renderFormularioEdicion();
  },

  renderFormularioEdicion(readonly = false) {
    const container = document.getElementById('encuestaContent');
    const e = this.data.encuesta;
    const disabled = readonly ? 'disabled' : '';

    const checked = (name, val) => e[name] == val ? 'checked' : '';
    const boolChecked = (name, val) => {
      if (e[name] === null || e[name] === undefined) return '';
      return (e[name] == true && val === 'true') || (e[name] == false && val === 'false') ? 'checked' : '';
    };

    container.innerHTML = `
      <form id="formEditEncuesta">
        <!-- Datos de Identificación (solo lectura) -->
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
          <h3 style="margin-bottom: 1rem;">Datos de Identificación</h3>
          <div class="encuesta-row-2col" style="margin-bottom: 1rem;">
            <div><strong>Num. Serie:</strong> ${e.num_serie}</div>
            <div><strong>Marca:</strong> ${e.marca || 'N/A'}</div>
          </div>
          <div class="encuesta-row-2col" style="margin-bottom: 1rem;">
            <div><strong>Modelo:</strong> ${e.modelo || 'N/A'}</div>
            <div><strong>Usuario:</strong> ${e.usuario || 'N/A'}</div>
          </div>
          <div class="encuesta-row-2col">
            <div><strong>Fecha Entrega:</strong> ${e.fecha_entrega ? new Date(e.fecha_entrega).toLocaleDateString('es-MX') : 'N/A'}</div>
            <div><strong>Fecha Evaluación:</strong> ${e.fecha_evaluacion ? new Date(e.fecha_evaluacion).toLocaleDateString('es-MX') : 'N/A'}</div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="encuesta-tabs-bar">
          <button type="button" class="encuesta-tab active" onclick="window.encuestaDetalleView.showTabEdit('ventas')">Ventas</button>
          <button type="button" class="encuesta-tab" onclick="window.encuestaDetalleView.showTabEdit('almacen')">Almacén</button>
          <button type="button" class="encuesta-tab" onclick="window.encuestaDetalleView.showTabEdit('observaciones')">Observaciones</button>
          <button type="button" class="encuesta-tab" onclick="window.encuestaDetalleView.showTabEdit('firmas')">Firmas</button>
        </div>

        <div class="encuesta-panel-edit" id="panel-edit-ventas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem;">
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">1. ¿Cómo calificaría la atención brindada por nuestro agente comercial antes, durante y después del protocolo de entrega?</label>
            <div class="encuesta-radio-group">
              ${[1,2,3,4,5].map(n => `
                <label class="encuesta-radio-label">
                  <input type="radio" name="p1_atencion_agente" value="${n}" ${checked('p1_atencion_agente', n)} ${disabled} />
                  <span>${n}</span>
                </label>
              `).join('')}
              <span class="encuesta-radio-hint">(1=Malo, 5=Excelente)</span>
            </div>
          </div>
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">2. ¿Cómo considera la explicación de las características técnicas y especificaciones de su equipo realizada por nuestro agente comercial?</label>
            <div class="encuesta-radio-group">
              ${[1,2,3,4,5].map(n => `
                <label class="encuesta-radio-label">
                  <input type="radio" name="p2_explicacion_tecnica" value="${n}" ${checked('p2_explicacion_tecnica', n)} ${disabled} />
                  <span>${n}</span>
                </label>
              `).join('')}
              <span class="encuesta-radio-hint">(1=Malo, 5=Excelente)</span>
            </div>
          </div>
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">3. ¿Nuestro agente comercial le ofreció un plan de financiamiento?</label>
            <div class="encuesta-radio-group">
              <label class="encuesta-radio-label"><input type="radio" name="p3_plan_financiamiento" value="true" ${boolChecked('p3_plan_financiamiento', 'true')} ${disabled} /> <span>Sí</span></label>
              <label class="encuesta-radio-label"><input type="radio" name="p3_plan_financiamiento" value="false" ${boolChecked('p3_plan_financiamiento', 'false')} ${disabled} /> <span>No</span></label>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">4. ¿Por qué medio conoció nuestros productos?</label>
            <div class="encuesta-radio-group">
              ${['evento', 'internet', 'redes_sociales', 'cliente', 'otro'].map(v => `
                <label class="encuesta-radio-label">
                  <input type="radio" name="p4_medio_conocimiento" value="${v}" ${checked('p4_medio_conocimiento', v)} ${disabled} />
                  <span>${{evento:'Evento', internet:'Internet', redes_sociales:'Redes Sociales', cliente:'Cliente', otro:'Otro'}[v]}</span>
                </label>
              `).join('')}
            </div>
          </div>
        </div>

        <div class="encuesta-panel-edit" id="panel-edit-almacen" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">5. ¿El tiempo de entrega fue según lo acordado?</label>
            <div class="encuesta-radio-group">
              <label class="encuesta-radio-label"><input type="radio" name="p5_tiempo_entrega" value="true" ${boolChecked('p5_tiempo_entrega', 'true')} ${disabled} /> <span>Sí</span></label>
              <label class="encuesta-radio-label"><input type="radio" name="p5_tiempo_entrega" value="false" ${boolChecked('p5_tiempo_entrega', 'false')} ${disabled} /> <span>No</span></label>
            </div>
          </div>
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">6. Al recibir su equipo, ¿nuestro personal le brindó asesoría técnica sobre su correcto funcionamiento y desempeño?</label>
            <div class="encuesta-radio-group">
              <label class="encuesta-radio-label"><input type="radio" name="p6_asesoria_tecnica" value="true" ${boolChecked('p6_asesoria_tecnica', 'true')} ${disabled} /> <span>Sí</span></label>
              <label class="encuesta-radio-label"><input type="radio" name="p6_asesoria_tecnica" value="false" ${boolChecked('p6_asesoria_tecnica', 'false')} ${disabled} /> <span>No</span></label>
            </div>
          </div>
          <div class="form-group" style="margin-bottom: 1.5rem;">
            <label class="form-label">7. ¿Nuestro personal técnico le explicó las CONDICIONES DE GARANTÍA y SERVICIOS DE MANTENIMIENTO de su equipo?</label>
            <div class="encuesta-radio-group">
              <label class="encuesta-radio-label"><input type="radio" name="p7_explicacion_garantia" value="true" ${boolChecked('p7_explicacion_garantia', 'true')} ${disabled} /> <span>Sí</span></label>
              <label class="encuesta-radio-label"><input type="radio" name="p7_explicacion_garantia" value="false" ${boolChecked('p7_explicacion_garantia', 'false')} ${disabled} /> <span>No</span></label>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">8. ¿Que tanto cumplió con sus expectativas el equipo entregado?</label>
            <div class="encuesta-radio-group">
              ${[1,2,3,4,5].map(n => `
                <label class="encuesta-radio-label">
                  <input type="radio" name="p8_cumplimiento_expectativas" value="${n}" ${checked('p8_cumplimiento_expectativas', n)} ${disabled} />
                  <span>${n}</span>
                </label>
              `).join('')}
              <span class="encuesta-radio-hint">(1=No cumplió, 5=Superó expectativas)</span>
            </div>
          </div>
        </div>

        <div class="encuesta-panel-edit" id="panel-edit-observaciones" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          <div class="form-group">
            <label class="form-label">Observaciones</label>
            <textarea name="observaciones" class="form-input" rows="5" placeholder="Comentarios adicionales del cliente..." style="text-transform: uppercase;" ${disabled}>${e.observaciones || ''}</textarea>
          </div>
        </div>

        <div class="encuesta-panel-edit" id="panel-edit-firmas" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1rem; display: none;">
          ${readonly ? '<h3 style="margin-bottom: 1rem;">Firmas</h3>' : ''}
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
            <div class="${readonly ? '' : 'firma-container-new'}" style="text-align: center;">
              ${readonly ? '' : '<label class="form-label firma-label">Firma Distribuidor</label>'}
              ${readonly ? '' : `<p style="margin: 0 0 0.5rem; font-weight: 600;">${e.distribuidor || 'No asignado'}</p>`}
              ${readonly ? `
                ${e.distribuidor_firma_url ? `<img src="${e.distribuidor_firma_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'">` : ''}
                <div style="border-top: 1px solid var(--gray-400); padding-top: 0.5rem; text-align: center;">
                  <strong>${e.distribuidor || '-'}</strong><br>
                  <small style="color: var(--text-muted);">Distribuidor</small>
                </div>
              ` : (e.distribuidor_firma_url ? `
                <img src="${e.distribuidor_firma_url}" style="width: 100%; max-height: 100px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
                <a href="javascript:void(0)" class="firma-limpiar" onclick="window.encuestaDetalleView.cambiarFirmaExistente('distribuidor')">Cambiar firma</a>
              ` : `
                <div class="firma-box">
                  <canvas id="firma-distribuidor" class="firma-canvas-new"></canvas>
                  <span class="firma-placeholder">Toque para firmar</span>
                </div>
                <a href="javascript:void(0)" class="firma-limpiar" onclick="window.encuestaDetalleView.limpiarFirma('distribuidor')">Limpiar</a>
              `)}
            </div>

            <div class="firma-container-new" style="text-align: center;">
              ${readonly ? '' : '<label class="form-label firma-label">Firma Responsable de Calidad</label>'}
              ${readonly ? '' : `<p style="margin: 0 0 0.5rem; font-weight: 600;">${e.responsable_calidad || 'No asignado'}</p>`}
              ${readonly ? `
                ${e.responsable_calidad_firma_url ? `<img src="${e.responsable_calidad_firma_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'">` : ''}
                <div style="border-top: 1px solid var(--gray-400); padding-top: 0.5rem; text-align: center;">
                  <strong>${e.responsable_calidad || '-'}</strong><br>
                  <small style="color: var(--text-muted);">Responsable de Calidad</small>
                </div>
              ` : (e.responsable_calidad_firma_url ? `
                <img src="${e.responsable_calidad_firma_url}" style="width: 100%; max-height: 100px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
                <a href="javascript:void(0)" class="firma-limpiar" onclick="window.encuestaDetalleView.cambiarFirmaExistente('responsable')">Cambiar firma</a>
              ` : `
                <div class="firma-box">
                  <canvas id="firma-responsable" class="firma-canvas-new"></canvas>
                  <span class="firma-placeholder">Toque para firmar</span>
                </div>
                <a href="javascript:void(0)" class="firma-limpiar" onclick="window.encuestaDetalleView.limpiarFirma('responsable')">Limpiar</a>
              `)}
            </div>
          </div>
        </div>

        ${readonly ? `
        ` : `
          <!-- Indicador de cambios sin guardar -->
          <div id="unsavedIndicator" style="display: none; background: var(--warning); color: white; padding: 0.5rem 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;">
            Hay cambios sin guardar
          </div>
          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button type="button" class="btn btn-secondary" onclick="window.encuestaDetalleView.cancelarEdicion()">
              Cancelar
            </button>
            <button type="submit" class="btn btn-primary">
              Guardar Cambios
            </button>
            ${permisos.can('encuestas_satisfaccion', 'cerrar') ? `
              <button type="button" class="btn btn-success" onclick="window.encuestaDetalleView.guardarYCompletar()">
                Completar
              </button>
            ` : ''}
          </div>
        `}
      </form>
    `;

    document.getElementById('formEditEncuesta').addEventListener('submit', (ev) => this.guardarEdicion(ev));

    // Actualizar header según modo
    if (readonly) {
      const header = document.getElementById('encuestaHeader');
      if (header) {
        header.innerHTML = `
          <div>
            <h2 class="card-title" style="margin: 0;">Encuesta de Satisfacción</h2>
            <small style="color: var(--text-muted);">Formato AMX-VTA-FR-08 | Completada</small>
          </div>
          <div style="display: flex; gap: 0.5rem;">
            <button class="btn btn-secondary" onclick="router.navigate('/ventas/encuestas')">
              &larr; Volver
            </button>
            ${permisos.canPrint('encuestas_satisfaccion') ? `
              <button class="btn btn-primary" onclick="router.navigate('/ventas/encuestas/${this.data.encuesta.id}/print')">
                🖨️ Imprimir
              </button>
              <button class="btn btn-success" onclick="window.encuestaDetalleView.descargarPDF()">
                📄 Descargar PDF
              </button>
            ` : ''}
          </div>
        `;
      }
    }

    // Detectar cambios sin guardar (solo en modo edición)
    if (!readonly) {
      const form = document.getElementById('formEditEncuesta');
      form.addEventListener('change', () => this._showUnsaved());
      form.addEventListener('input', () => this._showUnsaved());

      // Prevenir salida accidental
      this._beforeUnloadHandler = (e) => {
        if (this._hasUnsaved) {
          e.preventDefault();
          e.returnValue = '';
        }
      };
      window.addEventListener('beforeunload', this._beforeUnloadHandler);
    }

    // Inyectar estilos si no existen
    if (!document.querySelector('style[data-encuesta-tabs]')) {
      const style = document.createElement('style');
      style.setAttribute('data-encuesta-tabs', '');
      style.textContent = `
        .encuesta-tabs-bar {
          display: flex;
          padding: 0;
          background: transparent;
          border-bottom: 2px solid #e5e7eb;
          margin-bottom: 1rem;
        }
        .encuesta-tab {
          flex: 1;
          padding: 0.6rem 1rem;
          border: none;
          border-bottom: 3px solid transparent;
          margin-bottom: -2px;
          background: transparent;
          color: #6b7280;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          text-align: center;
        }
        .encuesta-tab:hover:not(.active) {
          color: #374151;
          border-bottom-color: #d1d5db;
        }
        .encuesta-tab.active {
          color: var(--primary);
          font-weight: 600;
          border-bottom-color: var(--primary);
        }
        .encuesta-row-2col {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }
        @media (max-width: 640px) {
          .encuesta-tab {
            padding: 0.4rem 0.5rem;
            font-size: 0.75rem;
          }
          .encuesta-row-2col {
            grid-template-columns: 1fr;
          }
        }
      `;
      document.head.appendChild(style);
    }
  },

  async descargarPDF() {
    const e = this.data.encuesta;
    if (!e) return;

    toast.info('Generando PDF...');

    try {
      if (typeof html2pdf === 'undefined') {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.2/html2pdf.bundle.min.js';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Error al cargar librería PDF'));
          document.head.appendChild(script);
        });
      }

      // Importar y renderizar la vista de impresión en un contenedor temporal
      const { default: PrintEncuesta } = await import('./PrintEncuesta.js');
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.id = 'tempPrintContent';
      document.body.appendChild(tempDiv);

      // Renderizar el HTML de impresión
      const response = await ventasService.obtenerEncuesta(e.id);
      const encuesta = response.data || response;
      PrintEncuesta.renderPrint.call(PrintEncuesta, encuesta);

      // Tomar el contenido generado
      const printContainer = document.querySelector('#content .print-container');
      const clonedContent = printContainer.cloneNode(true);
      // Agregar estilo para evitar página extra
      const style = document.createElement('style');
      style.textContent = '.print-container { padding: 5mm !important; } * { margin: 0; }';
      clonedContent.prepend(style);
      tempDiv.appendChild(clonedContent);

      const opt = {
        margin: [5, 5, 5, 5],
        filename: `AMX-VTA-FR-08_${e.num_serie}.pdf`,
        image: { type: 'png', quality: 1 },
        html2canvas: { scale: 3, useCORS: true, scrollY: 0, letterRendering: true },
        jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
        pagebreak: { mode: 'avoid-all' }
      };

      await html2pdf().set(opt).from(clonedContent).save();
      document.body.removeChild(tempDiv);

      // Restaurar la vista original
      this.renderFormularioEdicion(true);
      toast.success('PDF descargado');
    } catch (error) {
      toast.error('Error al generar PDF');
      console.error(error);
    }
  },

  volverALista() {
    if (this._hasUnsaved) {
      if (!confirm('Hay cambios sin guardar. ¿Está seguro de salir?')) return;
    }
    if (this._beforeUnloadHandler) window.removeEventListener('beforeunload', this._beforeUnloadHandler);
    router.navigate('/ventas/encuestas');
  },

  _showUnsaved() {
    this._hasUnsaved = true;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'block';
  },

  _clearUnsaved() {
    this._hasUnsaved = false;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'none';
  },

  showTabEdit(tab) {
    document.querySelectorAll('#encuestaContent .encuesta-tab').forEach(btn => btn.classList.remove('active'));
    const tabButton = document.querySelector(`#encuestaContent .encuesta-tab[onclick*="'${tab}'"]`);
    if (tabButton) tabButton.classList.add('active');

    document.querySelectorAll('.encuesta-panel-edit').forEach(p => p.style.display = 'none');
    const panel = document.getElementById(`panel-edit-${tab}`);
    if (panel) panel.style.display = 'block';

    if (tab === 'firmas') {
      // Siempre reiniciar pads para asegurar que canvas nuevos (tras re-render) estén vinculados
      this.signaturePad_distribuidor = null;
      this.signaturePad_responsable = null;
      this.initFirmas();
    }
  },

  cancelarEdicion() {
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator && indicator.style.display === 'block') {
      if (!confirm('Hay cambios sin guardar. ¿Está seguro de salir?')) return;
    }
    this.data.isEdit = false;
    this._clearUnsaved();
    if (this._beforeUnloadHandler) window.removeEventListener('beforeunload', this._beforeUnloadHandler);
    router.navigate('/ventas/encuestas');
  },

  async guardarEdicion(e) {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const enc = this.data.encuesta;

    const data = {
      fecha_entrega: formData.get('fecha_entrega') || undefined,
      fecha_evaluacion: formData.get('fecha_evaluacion') || undefined,
      p1_atencion_agente: formData.get('p1_atencion_agente') ? parseInt(formData.get('p1_atencion_agente')) : undefined,
      p2_explicacion_tecnica: formData.get('p2_explicacion_tecnica') ? parseInt(formData.get('p2_explicacion_tecnica')) : undefined,
      p3_plan_financiamiento: formData.get('p3_plan_financiamiento') != null ? formData.get('p3_plan_financiamiento') === 'true' : undefined,
      p4_medio_conocimiento: formData.get('p4_medio_conocimiento') || undefined,
      p5_tiempo_entrega: formData.get('p5_tiempo_entrega') != null ? formData.get('p5_tiempo_entrega') === 'true' : undefined,
      p6_asesoria_tecnica: formData.get('p6_asesoria_tecnica') != null ? formData.get('p6_asesoria_tecnica') === 'true' : undefined,
      p7_explicacion_garantia: formData.get('p7_explicacion_garantia') != null ? formData.get('p7_explicacion_garantia') === 'true' : undefined,
      p8_cumplimiento_expectativas: formData.get('p8_cumplimiento_expectativas') ? parseInt(formData.get('p8_cumplimiento_expectativas')) : undefined,
      observaciones: formData.get('observaciones') ? formData.get('observaciones').toUpperCase() : null
    };

    // Solo enviar campos con valor
    Object.keys(data).forEach(k => { if (data[k] === undefined || data[k] === null) delete data[k]; });

    try {
      this._showProgress('Subiendo firmas...');
      // Subir firmas si se dibujaron
      const firmaUrls = await this.subirFirmas();
      if (firmaUrls.distribuidor_firma_url) data.distribuidor_firma_url = firmaUrls.distribuidor_firma_url;
      if (firmaUrls.responsable_calidad_firma_url) data.responsable_calidad_firma_url = firmaUrls.responsable_calidad_firma_url;

      this._showProgress('Guardando encuesta...');
      await ventasService.actualizarEncuesta(enc.id, data);
      this._hideProgress();
      this._clearUnsaved();
      if (this._beforeUnloadHandler) window.removeEventListener('beforeunload', this._beforeUnloadHandler);
      toast.success('Encuesta actualizada exitosamente');
      // Recargar la encuesta para refrescar el render de firmas (muestra imagen + "Cambiar firma")
      await this.cargarEncuesta(enc.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al actualizar encuesta');
      console.error(error);
    }
  }
};
